import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

export const Container = styled(Flex).attrs({
  py: [32, 32, 64, 96],
})`
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
  color: ${themeGet('colors.white')};
`
